// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-form-point[data-v-65e77b54]{font-size:.85em;opacity:.9;line-height:1.4}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
